var cov_f5kninar6 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Transfer/btns.tsx",
      hash = "2e2c4065f667d67dae645bb639563616a54d2445",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Transfer/btns.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 16
        }
      },
      "1": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 45
        }
      },
      "2": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 45
        }
      },
      "3": {
        start: {
          line: 22,
          column: 29
        },
        end: {
          line: 22,
          column: 39
        }
      },
      "4": {
        start: {
          line: 23,
          column: 20
        },
        end: {
          line: 23,
          column: 29
        }
      },
      "5": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 26,
          column: 5
        }
      },
      "6": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 54
        }
      },
      "7": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 18
        }
      },
      "8": {
        start: {
          line: 31,
          column: 47
        },
        end: {
          line: 31,
          column: 57
        }
      },
      "9": {
        start: {
          line: 33,
          column: 20
        },
        end: {
          line: 33,
          column: 37
        }
      },
      "10": {
        start: {
          line: 35,
          column: 21
        },
        end: {
          line: 35,
          column: 66
        }
      },
      "11": {
        start: {
          line: 35,
          column: 51
        },
        end: {
          line: 35,
          column: 65
        }
      },
      "12": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 46
        }
      },
      "13": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 73
        }
      },
      "14": {
        start: {
          line: 44,
          column: 42
        },
        end: {
          line: 44,
          column: 52
        }
      },
      "15": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 53,
          column: 5
        }
      },
      "16": {
        start: {
          line: 46,
          column: 19
        },
        end: {
          line: 49,
          column: 7
        }
      },
      "17": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 40
        }
      },
      "18": {
        start: {
          line: 51,
          column: 19
        },
        end: {
          line: 51,
          column: 40
        }
      },
      "19": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 17
        }
      },
      "20": {
        start: {
          line: 54,
          column: 18
        },
        end: {
          line: 57,
          column: 5
        }
      },
      "21": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 39
        }
      },
      "22": {
        start: {
          line: 58,
          column: 17
        },
        end: {
          line: 58,
          column: 39
        }
      },
      "23": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 16
        }
      },
      "24": {
        start: {
          line: 63,
          column: 36
        },
        end: {
          line: 63,
          column: 46
        }
      },
      "25": {
        start: {
          line: 65,
          column: 20
        },
        end: {
          line: 65,
          column: 37
        }
      },
      "26": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 90,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        loc: {
          start: {
            line: 15,
            column: 48
          },
          end: {
            line: 19,
            column: 3
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        loc: {
          start: {
            line: 21,
            column: 15
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 21
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        },
        loc: {
          start: {
            line: 30,
            column: 27
          },
          end: {
            line: 41,
            column: 3
          }
        },
        line: 30
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 35,
            column: 46
          },
          end: {
            line: 35,
            column: 47
          }
        },
        loc: {
          start: {
            line: 35,
            column: 51
          },
          end: {
            line: 35,
            column: 65
          }
        },
        line: 35
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 43,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        },
        loc: {
          start: {
            line: 43,
            column: 34
          },
          end: {
            line: 60,
            column: 3
          }
        },
        line: 43
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        },
        loc: {
          start: {
            line: 62,
            column: 11
          },
          end: {
            line: 91,
            column: 3
          }
        },
        line: 62
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 40,
            column: 10
          },
          end: {
            line: 40,
            column: 34
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 40,
            column: 18
          },
          end: {
            line: 40,
            column: 23
          }
        }, {
          start: {
            line: 40,
            column: 26
          },
          end: {
            line: 40,
            column: 34
          }
        }],
        line: 40
      },
      "1": {
        loc: {
          start: {
            line: 43,
            column: 19
          },
          end: {
            line: 43,
            column: 32
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 43,
            column: 26
          },
          end: {
            line: 43,
            column: 32
          }
        }],
        line: 43
      },
      "2": {
        loc: {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 53,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 53,
            column: 5
          }
        }, {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 53,
            column: 5
          }
        }],
        line: 45
      },
      "3": {
        loc: {
          start: {
            line: 47,
            column: 45
          },
          end: {
            line: 47,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 45
          },
          end: {
            line: 47,
            column: 58
          }
        }, {
          start: {
            line: 47,
            column: 62
          },
          end: {
            line: 47,
            column: 77
          }
        }],
        line: 47
      },
      "4": {
        loc: {
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 51,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 51,
            column: 40
          }
        }, {
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 51,
            column: 40
          }
        }],
        line: 51
      },
      "5": {
        loc: {
          start: {
            line: 55,
            column: 43
          },
          end: {
            line: 55,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 43
          },
          end: {
            line: 55,
            column: 56
          }
        }, {
          start: {
            line: 55,
            column: 60
          },
          end: {
            line: 55,
            column: 76
          }
        }],
        line: 55
      },
      "6": {
        loc: {
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 58,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 58,
            column: 39
          }
        }, {
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 58,
            column: 39
          }
        }],
        line: 58
      },
      "7": {
        loc: {
          start: {
            line: 71,
            column: 22
          },
          end: {
            line: 71,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 22
          },
          end: {
            line: 71,
            column: 29
          }
        }, {
          start: {
            line: 71,
            column: 33
          },
          end: {
            line: 71,
            column: 53
          }
        }],
        line: 71
      },
      "8": {
        loc: {
          start: {
            line: 81,
            column: 22
          },
          end: {
            line: 81,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 81,
            column: 22
          },
          end: {
            line: 81,
            column: 29
          }
        }, {
          start: {
            line: 81,
            column: 33
          },
          end: {
            line: 81,
            column: 53
          }
        }],
        line: 81
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Transfer/btns.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { getKey } from '../utils/uid';
import Button from '../Button';
import { Component } from '../component';
import { transferClass } from './styles';
import icons from '../icons';
import { isRTL } from '../config';

var Btns =
/*#__PURE__*/
function (_Component) {
  _inherits(Btns, _Component);

  var _super = _createSuper2(Btns);

  function Btns(props) {
    var _this;

    _classCallCheck(this, Btns);

    cov_f5kninar6.f[0]++;
    cov_f5kninar6.s[0]++;
    _this = _super.call(this, props);
    _this.toSource = void 0;
    _this.toTarget = void 0;
    cov_f5kninar6.s[1]++;
    _this.toSource = _this.change.bind(_assertThisInitialized(_this), 0);
    cov_f5kninar6.s[2]++;
    _this.toTarget = _this.change.bind(_assertThisInitialized(_this), 1);
    return _this;
  }

  _createClass(Btns, [{
    key: "getDataMap",
    value: function getDataMap() {
      cov_f5kninar6.f[1]++;

      var _ref = (cov_f5kninar6.s[3]++, this.props),
          data = _ref.data,
          keygen = _ref.keygen;

      var dataMap = (cov_f5kninar6.s[4]++, new Map());
      cov_f5kninar6.s[5]++;

      for (var i = 0; i < data.length; i++) {
        cov_f5kninar6.s[6]++;
        dataMap.set(getKey(data[i], keygen, i), data[i]);
      }

      cov_f5kninar6.s[7]++;
      return dataMap;
    }
  }, {
    key: "change",
    value: function change(index) {
      cov_f5kninar6.f[2]++;

      var _ref2 = (cov_f5kninar6.s[8]++, this.props),
          setSelecteds = _ref2.setSelecteds,
          selecteds = _ref2.selecteds,
          datum = _ref2.datum;

      var dataMap = (cov_f5kninar6.s[9]++, this.getDataMap());
      var newValue = (cov_f5kninar6.s[10]++, selecteds[1 - index].map(function (c) {
        cov_f5kninar6.f[3]++;
        cov_f5kninar6.s[11]++;
        return dataMap.get(c);
      })); // const newValue = selecteds[1 - index].map(c => data.find((d, i) => getKey(d, keygen, i) === c))

      cov_f5kninar6.s[12]++;
      setSelecteds(1 - index, []);
      cov_f5kninar6.s[13]++;
      datum[index ? (cov_f5kninar6.b[0][0]++, 'add') : (cov_f5kninar6.b[0][1]++, 'remove')](newValue, undefined, undefined, true);
    }
  }, {
    key: "renderButtonText",
    value: function renderButtonText() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_f5kninar6.b[1][0]++, 'left');
      cov_f5kninar6.f[4]++;

      var _ref3 = (cov_f5kninar6.s[14]++, this.props),
          operations = _ref3.operations,
          operationIcon = _ref3.operationIcon;

      cov_f5kninar6.s[15]++;

      if (mode === 'left') {
        cov_f5kninar6.b[2][0]++;
        var left = (cov_f5kninar6.s[16]++, [
        /*#__PURE__*/
        React.createElement(React.Fragment, {
          key: "operationIcon",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 47,
            columnNumber: 9
          }
        }, (cov_f5kninar6.b[3][0]++, operationIcon) && (cov_f5kninar6.b[3][1]++, icons.AngleLeft)),
        /*#__PURE__*/
        React.createElement(React.Fragment, {
          key: "operations",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 48,
            columnNumber: 9
          }
        }, operations[1])]);
        cov_f5kninar6.s[17]++;

        if (isRTL()) {
          cov_f5kninar6.b[4][0]++;
          cov_f5kninar6.s[18]++;
          return left.reverse();
        } else {
          cov_f5kninar6.b[4][1]++;
        }

        cov_f5kninar6.s[19]++;
        return left;
      } else {
        cov_f5kninar6.b[2][1]++;
      }

      var right = (cov_f5kninar6.s[20]++, [
      /*#__PURE__*/
      React.createElement(React.Fragment, {
        key: "operationIcon",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 55,
          columnNumber: 7
        }
      }, (cov_f5kninar6.b[5][0]++, operationIcon) && (cov_f5kninar6.b[5][1]++, icons.AngleRight)),
      /*#__PURE__*/
      React.createElement(React.Fragment, {
        key: "operations",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 56,
          columnNumber: 7
        }
      }, operations[0])]);
      cov_f5kninar6.s[21]++;

      if (isRTL()) {
        cov_f5kninar6.b[6][0]++;
        cov_f5kninar6.s[22]++;
        return right.reverse();
      } else {
        cov_f5kninar6.b[6][1]++;
      }

      cov_f5kninar6.s[23]++;
      return right;
    }
  }, {
    key: "render",
    value: function render() {
      cov_f5kninar6.f[5]++;

      var _ref4 = (cov_f5kninar6.s[24]++, this.props),
          selecteds = _ref4.selecteds,
          disabled = _ref4.disabled;

      var disable = (cov_f5kninar6.s[25]++, disabled === true);
      cov_f5kninar6.s[26]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: transferClass('btns'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 67,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 68,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement(Button, {
          type: "primary",
          disabled: (cov_f5kninar6.b[7][0]++, disable) || (cov_f5kninar6.b[7][1]++, !selecteds[0].length),
          size: "small",
          className: transferClass('btns-button', 'btns-bottom'),
          onClick: this.toTarget,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 69,
            columnNumber: 11
          }
        }, this.renderButtonText('right')),
        /*#__PURE__*/
        React.createElement("br", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 78,
            columnNumber: 11
          }
        }),
        /*#__PURE__*/
        React.createElement(Button, {
          type: "primary",
          disabled: (cov_f5kninar6.b[8][0]++, disable) || (cov_f5kninar6.b[8][1]++, !selecteds[1].length),
          size: "small",
          className: transferClass('btns-button'),
          onClick: this.toSource,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 79,
            columnNumber: 11
          }
        }, this.renderButtonText('left'))))
      );
    }
  }]);

  return Btns;
}(Component);

export default Btns;